import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import compact from 'lodash/compact';

import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled';
import { FooterNavigation } from '../FooterNavigation/FooterNavigation';
import { WebsiteLocaleFragment } from '../../../graphql.schema';
import { v4tov3base } from '../../lib/mapV4toV3';

import * as styles from './Footer.module.scss';

type FooterProps = {
  websiteLocale: WebsiteLocaleFragment;
};
const staticYear = new Date().getFullYear(); // This happens once at module scope

const Footer = ({ websiteLocale }: FooterProps) => {
  // @ts-ignore

  const [websiteLocaleFromV4, setWebsiteLocaleFromV4] = React.useState<WebsiteLocaleFragment | null>(null);

  React.useEffect(() => {
    // Only runs on client
    const transformed = v4tov3base(websiteLocale);
    setWebsiteLocaleFromV4(transformed);
  }, [websiteLocale]);
  
  if (!websiteLocaleFromV4) return null; 

  return (
    <footer
      dir={`${websiteLocaleFromV4.hasRightToLeftLanguage ? 'rtl' : 'ltr'}`}
      className={classnames(styles.root, 'container')}
    >
      <div className="footer">
        <div className={classnames('columns', styles.lowerFooter)}>
          <div className="column is-6">
            <div className="columns is-mobile">
              <div className="column is-6">
                <FooterNavigation items={compact(websiteLocaleFromV4?.footerLeftLinks)} />
              </div>
              <div className="column is-6">
                <FooterNavigation items={compact(websiteLocaleFromV4?.footerRightLinks)} />
              </div>
            </div>
          </div>

          <div className={classnames(styles.social, 'has-text-right-desktop column is-6')}>
            <p className={classnames('is-text-3 black-2 my-5 has-text-right-desktop', styles.metaInfo)}>
              {websiteLocaleFromV4.footerMetaInfo}
            </p>
            {compact(websiteLocaleFromV4.socialLinks).map((link, idx) => (
              <StrapiLinkUnstyled
                {...link}
                className={classnames(styles.padding, 'is-text-3')}
                key={`footer-social-${idx}`}
              >
                {link.title}
              </StrapiLinkUnstyled>
            ))}
          </div>
        </div>
        <div className="columns footer-bottom is-align-items-center">
          <div className="column is-half">
            <p className="is-block is-text-3 black-3 mr-3 has-text-left">
              <FormattedMessage id="copyright" values={{ year: staticYear }}  />
            </p>
          </div>
          <div className="column is-half has-text-right-desktop">
            <div className={classnames(styles.legal)}>
              {compact(websiteLocaleFromV4.legalLinks).map((link, idx) => (
                <StrapiLinkUnstyled {...link} className={styles.padding} key={`footer-legal-${idx}`}>
                  {link.title}
                </StrapiLinkUnstyled>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
